import { render } from "./InputNameDialog.vue?vue&type=template&id=40824c7a&ts=true"
import script from "./InputNameDialog.vue?vue&type=script&lang=ts"
export * from "./InputNameDialog.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__